// extracted by mini-css-extract-plugin
module.exports = {"s952qyd":"s952qyd","a34lxg1":"a34lxg1"};